import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocumentWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6693 1.89124V5.33335C11.6693 5.80006 11.6693 6.03342 11.7601 6.21168C11.84 6.36848 11.9675 6.49596 12.1243 6.57586C12.3025 6.66669 12.5359 6.66669 13.0026 6.66669H16.4447M13.3359 10.8333H6.66927M13.3359 14.1666H6.66927M8.33594 7.49996H6.66927M11.6693 1.66663H7.33594C5.93581 1.66663 5.23574 1.66663 4.70096 1.93911C4.23056 2.17879 3.8481 2.56124 3.60842 3.03165C3.33594 3.56643 3.33594 4.26649 3.33594 5.66663V14.3333C3.33594 15.7334 3.33594 16.4335 3.60842 16.9683C3.8481 17.4387 4.23056 17.8211 4.70096 18.0608C5.23574 18.3333 5.93581 18.3333 7.33594 18.3333H12.6693C14.0694 18.3333 14.7695 18.3333 15.3042 18.0608C15.7747 17.8211 16.1571 17.4387 16.3968 16.9683C16.6693 16.4335 16.6693 15.7334 16.6693 14.3333V6.66663L11.6693 1.66663Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDocumentWhite;
